import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import RemoveOutlinedIcon from "@mui/icons-material/RemoveOutlined";
import type { CSSProperties } from "react";

import styles from "./style.module.scss";

/**
 * Add inline text button, common used in our forms
 */
interface IInlineButton {
    onClick: () => void;
    children: React.ReactNode;
    /**
     * Custom icon for button
     */
    icon?: React.ReactNode;
    /**
     * If no custom icon, toggle + / - icon
     */
    open?: boolean;
    /**
     * Style for icon
     */
    plusIconStyle?: CSSProperties;
    /**
     * Hide icon
     */
    hideIcon?: boolean;
    /**
     * Size
     */
    size?: "small" | "default";
    /**
     * CSS Properties
     */
    style?: CSSProperties;
    /**
     * Disable button
     */
    disabled?: boolean;
}

const InlineButton = ({
    onClick,
    children,
    icon,
    open,
    plusIconStyle = { width: 16, height: 16 },
    hideIcon = false,
    size = "default",
    style,
    disabled,
}: IInlineButton) => {
    const defaultStyles: Record<string, CSSProperties> = {
        small: { fontSize: "12px" },
        default: {},
    };
    const disabledStyles: CSSProperties = {
        opacity: 0.5,
        cursor: "not-allowed",
        pointerEvents: "none",
    };
    return (
        <div
            className={styles["inline-button"]}
            onClick={onClick}
            style={{ ...style, ...defaultStyles[size], ...(disabled && disabledStyles) }}
        >
            {!hideIcon && (
                <>
                    {icon ??
                        (open ? (
                            <RemoveOutlinedIcon sx={{ width: 14, height: 14 }} />
                        ) : (
                            <AddOutlinedIcon sx={plusIconStyle} />
                        ))}
                </>
            )}
            {children}
        </div>
    );
};

export default InlineButton;
